import styled from 'styled-components';

export const PerformerTaskCardStyle = {
  container: {
    borderLeft: '5px solid #ff9d2b',
    backgroundColor: '#fafafa',
    padding: '16px',
    width: '100%',
    justifyContent: 'space-between',
    wordWrap: 'break-word',
    alignItems: 'center',
    gap: '20px',
  },
  Heading: {
    color: '#1A1A1A',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '21px',
  },
  SubHeading: {
    color: '#52525B',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '18px',
  },
};

export const PerformersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const PerformerTableStyle = {
  backgroundColor: '#fff',
  gap: '12px',
};
